import { Injectable, } from "@angular/core";
import { MICustomFunctionsParams } from "../../../../models/fields/custom-function-params";
import { CustomItemFourDigitsService, MCFormisFieldAutoCompleteService, MCPersonalImportService, Regex } from "@maslul/common-services";
import { RequestApprovalTypeDetailsStore } from "../../../store/approval-type-details-store";



@Injectable({
    providedIn: 'root'
})
export class MICustomBookService {



    initCustomItemList(customFunctionsObj: MICustomFunctionsParams) {

        const value = customFunctionsObj?.value;
        const injector = customFunctionsObj.injector;
        const personalImportService = injector.get(MCPersonalImportService);

        const formisFieldAutoCompleteService = injector.get(MCFormisFieldAutoCompleteService);
        const requestApprovalTypeDetailsStore = injector.get(RequestApprovalTypeDetailsStore);
        const customItemFourDigitsService: CustomItemFourDigitsService = injector.get(CustomItemFourDigitsService);

        const is4DigitsCustomItem = requestApprovalTypeDetailsStore.getSnapshot().is4DigitsCustomItem
            && customFunctionsObj.value?.length == 4;

        const customItemField = customFunctionsObj?.formisForm?.fields
            ?.find(x => x.key == 'customItem')?.
            fieldGroup?.find(x => x.key == 'customItem');
        formisFieldAutoCompleteService.noMessage.next({ condition: false, fieldName: "customItem" });

        if (Regex.digitsWithNegative.test(value) && value?.length >= 4) {
            //טוען נתונים רק לשדה ספציפי

            formisFieldAutoCompleteService.loadingList.next({ condition: true, fieldName: "customItem" });
            personalImportService.getCustomItemData(value).subscribe((res) => {
                formisFieldAutoCompleteService.noMessage.next({ condition: false, fieldName: "customItem" });

                formisFieldAutoCompleteService.loadingList.next({ condition: false, fieldName: "customItem" });
                const options = is4DigitsCustomItem ? customItemFourDigitsService.groupCustomItemBy4Digits(res) : res;
                if (customItemField?.props?.options) {
                    customItemField.props.options = options?.map((item: any) => ({ value: item.itemNum, label: item.itemNum })) || [];

                    formisFieldAutoCompleteService.externalRefreshList.next(true);
                }

            });

        }
        else {
            formisFieldAutoCompleteService.noMessage.next({ condition: true, fieldName: "customItem" });

            formisFieldAutoCompleteService.externalRefreshList.next(true);
        }
    }
}

